module.exports = __webpack_public_path__ + "img/Early_communication.cf253fff.jpg";